import * as e from "react";
import { forwardRef as l } from "react";
const n = l(function(C, o) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: o,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...C
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 3C16.9703 3 21 7.02975 21 12C21 16.9703 16.9703 21 12 21C7.02975 21 3 16.9703 3 12C3 7.02975 7.02975 3 12 3ZM6.11775 6.58575C4.2465 9.82725 5.8065 14.2005 9.5625 16.3688C13.3185 18.5378 17.886 17.7023 19.7572 14.4608C21.6285 11.2192 20.0685 6.846 16.3125 4.67775C12.5565 2.5095 7.989 3.34425 6.11775 6.585V6.58575ZM12.5122 4.24575L12.42 4.25925C11.1195 4.4565 9.978 5.1495 9.3285 6.2745C8.08575 8.427 9.114 11.3468 11.625 12.7965C14.136 14.2463 17.1788 13.677 18.4215 11.5245C19.0868 10.3733 19.101 9.00225 18.5865 7.75425C19.944 9.72975 20.2237 12.153 19.1077 14.0858C17.4577 16.9432 13.356 17.6932 9.9375 15.7192C6.519 13.746 5.11725 9.8175 6.76725 6.96075C7.88325 5.028 10.122 4.059 12.5122 4.24575ZM15.375 6.30075C16.7677 7.10625 17.5088 8.60625 16.848 9.75C16.1873 10.8945 14.5177 11.0025 13.125 10.1985C11.7323 9.3945 10.9913 7.8945 11.652 6.75C12.3127 5.6055 13.9823 5.4975 15.375 6.3015V6.30075Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  n as Bowls
};
